import {Pipe, PipeTransform} from '@angular/core';
import {QualityCheck, SimpleCheck} from "../api";
import CheckTypeEnum = QualityCheck.CheckTypeEnum;

@Pipe({name: 'checkType'})
export class CheckTypePipe implements PipeTransform {

  transform(value: CheckTypeEnum, checkRuleType?: SimpleCheck.CheckRuleTypeEnum): string {
    switch (value) {
      case "QUALITY":
        return "All-Right Check";
      case "HOAI":
        return "All-In Check - HOAI";
      case "IFC":
        return "All-In Check - LOIplus";
      case "BASE":
        return "All-In Check - LOIplus";
      case "MY_CHECK":
        if (checkRuleType) {
          switch (checkRuleType) {
            case 'IDS':
              return "myCheck – IDS";
            case 'HYBRID':
              return "myCheck – Hybrid";
            case 'AI':
              return "myCheck – KI";
            default:
              return "myCheck – " + checkRuleType;
          }
        }
        return "myCheck";
    }
    return "Unbekannter Check";
  }
}
